var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.94731,
    cy: 2.84965,
    r: 2.84965,
    fill: "#888888"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.5C4.5 7.46244 6.96243 5 10 5V5C13.0376 5 15.5 7.46243 15.5 10.5V12.3333H4.5V10.5Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2518 15.5429C15.4487 15.4389 14.7201 16.0065 14.6245 16.8106C14.5289 17.6148 15.1024 18.351 15.9055 18.455C16.7086 18.559 17.4372 17.9915 17.5328 17.1873C17.6284 16.3832 17.0549 15.6469 16.2518 15.5429ZM12.9148 13.182L15.8587 17.1615L16.2986 16.8364L13.3547 12.8569L12.9148 13.182Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84785 15.5427C4.65095 15.4387 5.37951 16.0062 5.47514 16.8104C5.57076 17.6145 4.99723 18.3507 4.19412 18.4548C3.39102 18.5588 2.66245 17.9912 2.56683 17.1871C2.47121 16.3829 3.04474 15.6467 3.84785 15.5427ZM7.18484 13.1817L4.24094 17.1613L3.80103 16.8362L6.74493 12.8567L7.18484 13.1817Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10411 17.3075C9.66437 16.7228 10.5727 16.7228 11.133 17.3075C11.6933 17.8923 11.6933 18.8403 11.133 19.425C10.5727 20.0097 9.66437 20.0097 9.10411 19.425C8.54384 18.8403 8.54384 17.8923 9.10411 17.3075ZM10.3661 13.3375L10.3876 18.365L9.84957 18.3675L9.82809 13.34L10.3661 13.3375Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.895905f3ade25af37cc48f3184d2ab44.svg";
export { ForwardRef as ReactComponent };